
import { css } from 'lit';
export default css`
:host {
  width: 100%;
}

  :host([imagestyle="cta-image"]) {
    height: 100%;
  }

.responsive-image {
  display: block;
  min-height: 100%;
  width: 100%;
}

.responsive-image__image {
  min-height: 100%;
}

.responsive-image__image {
  width: 100%;
}

.image-fill--cta-image {
  display: flex;
  justify-content: center;
}

.image-fill--cta-image .responsive-image__image {
  width: 100%;
}

.image-fill--cta-image .responsive-image__image {
  max-width: none;
}

@media (min-width: 768px) {

  .image-fill--cta-image .responsive-image__image {
    height: 100%;
  }
}

@media (min-width: 1024px) {

  .image-fill--cta-image .responsive-image__image {
    width: auto;
  }
}

@media (min-width: 1600px) {

  .image-fill--cta-image .responsive-image__image {
    width: 100%;
  }
}

@media (min-width: 1200px) {

.image-fill--cta-image {
    height: 100%;
  }

    .image-fill--cta-image * > {
      height: 100%;
    }
  }

.image-fill--cta-location-image {
  display: flex;
  justify-content: center;
}

.image-fill--cta-location-image .responsive-image__image {
  height: 100%;
}

.image-fill--cta-location-image .responsive-image__image {
  width: 100%;
}

.image-fill--cta-location-image .responsive-image__image {
  max-width: none;
}

@media (min-width: 1024px) {

  .image-fill--cta-location-image .responsive-image__image {
    width: auto;
  }
}

@media (min-width: 1600px) {

  .image-fill--cta-location-image .responsive-image__image {
    width: 100%;
  }
}

@media (min-width: 1024px) {

  .image-fill--cta-featured {
    height: 100%;
  }

  .image-fill--cta-featured {
    width: auto;
  }
}

@media (min-width: 1024px) {

  .image-fill--cta-featured .responsive-image__image {
    height: 100%;
  }
}

@media (min-width: 1024px) {

  .image-fill--cta-featured .responsive-image__image {
    width: auto;
  }
}

@media (min-width: 1024px) {

  .image-fill--cta-featured .responsive-image__image {
    max-width: none;
  }
}

.image-fill--cta-card-hero {
  overflow: hidden;
  height: 100%;
  width: 100vw;
  margin-left: -1rem;
}

.image-fill--cta-card-hero .responsive-image__image {
    -o-object-fit: cover;
       object-fit: cover;
}

@media (min-width: 768px) {

.image-fill--cta-card-hero {
    width: 100%;
    margin-left: initial
}
  }

@media (min-width: 1024px) {

.image-fill--cta-card-hero {
    height: 489px
}
  }
`;